export default function ({ route, redirect }) {
    // 你可以在这里添加更多的逻辑，例如检查特定的路由
    // 如果该路由不存在，就重定向到首页
    if (route.fullPath.indexOf('/enterprise/enterpriseDetail') > -1 || route.fullPath.indexOf('.php') > -1 || route.fullPath.indexOf('enterprise/enterpriseIndex') > -1) {
      return redirect('/')
    }
  }